export default __webpack_public_path__ + "2bf712affbd424dec87b257e822b2c4b.png";